import AxiosInstance from "../instance";
import {emptyFn} from "../utils";

const getAirportCodes = async (searchText: string) => {
    const response = await AxiosInstance.getInstance().get("/groupapi/airport-codes", {
        params: {
            airport: searchText
        }
    }).catch(emptyFn);
    return response;
};

const getTripPurpose = async (data: {
    departureDate: string;
    returnDate: string;
    origin: string;
    destination: string;
}) => {
    const response = await AxiosInstance.getInstance().get("/groupapi/predict-trip-purpose", {
        params: {
            departure_date: data.departureDate,
            return_date: data.returnDate,
            origin_location_code: data.origin,
            destination_location_code: data.destination
        }
    });
    return response;
};

export {getAirportCodes, getTripPurpose};


// WEBPACK FOOTER //
// ./src/api/models/TripPurpose.ts